import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { LogDetailsModalComponent } from 'src/app/shared/components/log-details-modal/log-details-modal.component';
import { TableComponent } from 'src/app/shared/components/table/table.component';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { RequestLogService } from 'src/app/shared/services/API/integration-it4d/request-log.service';
import { RequestTypeModel } from 'src/app/shared/services/models/integration-it4d/request-type.model';
import { LogRequestsStruct } from 'src/app/shared/services/structs/integration-it4d/log-requests.struct';

@Component({
  selector: 'app-log-it4d',
  templateUrl: './log-it4d.component.html',
  styleUrls: ['./log-it4d.component.css']
})
export class LogIt4dComponent implements OnInit {
  constructor(private alertService: AlertService,
    private requestLogService: RequestLogService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
  ) { }
  
  @ViewChild(MatPaginator) paginator: MatPaginator;

  menuModuleEnum: MenuModuleEnum = MenuModuleEnum.support;
  menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.log_batch_list;

  isLoading: boolean = true;
  fullListSize: number = 0;
  listRequestType: RequestTypeModel[] = [];
  listLog: any[] = [];

  idHealthUnit: number = null;
  idRequestType: number = null;

  searchText: string = null;
  selectedPeriod: Date = null;

  columns: { header: string, field: string, isAction?: boolean, width?: string }[] = [
    { header: 'ID Unidade de Saúde', field: 'idHealthUnit', width: '6%' },
    { header: 'Log Solicitante', field: 'jsonRequest', width: '10%' },
    { header: 'Log Resposta', field: 'jsonResponse', width: '10%' },
    { header: 'ID Episódio', field: 'idEpisode', width: '7%' },
    { header: 'Data de inclusão', field: 'datetimeInclusion', width: '10%' },
    { header: 'Tipo de solicitação', field: 'requestTypeName', width: '10%' },
    { header: 'Ações', field: 'actions', isAction: true, width: '2%' }
  ];

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.paramMap.get('idHealthUnit'))
      this.idHealthUnit = parseInt(this.activatedRoute.snapshot.paramMap.get('idHealthUnit'));

    this.search(0);
  }

  changePage(event: PageEvent) {
    this.search(event.pageIndex);
  }

  buttonSearch() {
    if (this.isLoading)
      return;

    this.paginator.firstPage();
    this.search(0);
  }

  private timeoutKeySearch: any = null;

  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13)
        $this.search(0);
    }, 1000);
  }

  cancel() {
    this.searchText = null;
    this.idRequestType = null;
    this.selectedPeriod = null;
    this.search(0);
  }

  search(pageIndex: number) {
    this.isLoading = true;
    this.listLog = null;

    if (this.selectedPeriod instanceof Date)
      this.selectedPeriod.setHours(0, 0, 0, 0);

    let request = {
      datetimeInitRequest: this.selectedPeriod,
      searchText: this.searchText,
      idHealthUnit: this.idHealthUnit,
      pageIndex: pageIndex,
      idRequestType: this.idRequestType
    }

    this.requestLogService.search(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.listRequestType = response?.listRequestType;

        if (response?.listLogRequestsStruct.length > 0) {
          this.fullListSize = response.fullListSize;
          this.listLog = this.transformToTableRows(response.listLogRequestsStruct);
        }
        else {
          this.listLog = null;
          this.fullListSize = 0;
        }

        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  logDetails(event: any) {
    let numberOfLinesInTextPatientExitLog = this.countLinesInArea(event.jsonRequest, 825, 16);
    const dialogRef = this.dialog.open(LogDetailsModalComponent, {
      panelClass: 'custom-dialog-class',
      height: '90vh',
      disableClose: true,
      data: {
        logRequestDetails: event.jsonRequest,
        logResponseDetails: event.jsonResponse,
        numberOfLinesInTextPatientExitLog
      }
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
      }
    });
  }

  countLinesInArea(text: string, areaWidth: number, fontSize: number): number {
    if (!text || text.trim() === "")
      return 0;

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return 0;

    context.font = `${fontSize}px Arial`;

    const words = text.split(' ');
    let lineWidth = 0;
    let lines = 1;

    for (const word of words) {
      const wordWidth = context.measureText(word + ' ').width;
      if (lineWidth + wordWidth > areaWidth) {
        lines++;
        lineWidth = wordWidth; // Começa uma nova linha
      }
      else
        lineWidth += wordWidth;
    }

    return lines;
  }

  transformToTableRows(listLog: LogRequestsStruct[]) {
    return listLog.map(log => {
      const handleInvalidJson = (jsonString: string): any => {
        if (jsonString.startsWith("INVALID_JSON: "))
          return jsonString.replace("INVALID_JSON: ", ""); // Remove a marcação e exibe como string

        try {
          return JSON.parse(jsonString);
        }
        catch {
          return jsonString; // Se ainda assim der erro, exibe como string
        }
      };

      let logRequest = handleInvalidJson(log.request || "{}");
      let formattedLogData = this.beautify(logRequest);

      let logResponse = handleInvalidJson(log.response || "{}");
      let formattedLogResponseData = this.beautify(logResponse);

      return {
        requestTypeName: this.listRequestType?.find(x => x.idRequestType == log.idRequestType)?.requestTypeName,
        datetimeInclusion: log.datetimeInclusion,
        idHealthUnit: log.idHealthUnit,
        jsonRequest: formattedLogData,
        jsonResponse: formattedLogResponseData,
        idEpisode: log.idEpisodeToLife
      };
    });
  }

  beautify(json: any): string {
    return typeof json === "string" ? json : JSON.stringify(json, null, 2);
  }
}
